import { Subject } from "rxjs";

export class StructureSelection {

  stationGroupId: number;
  stationSetId: number;
  stationId: number;
  valid: boolean;

  constructor(selection?: Partial<StructureSelection>) {
    if (selection) {
      this.stationGroupId = selection.stationGroupId;
      this.stationSetId = selection.stationSetId;
      this.stationId = selection.stationId;
      this.valid = selection.valid;
    }
  }
}

export enum StructureSelectionScope {
  ANY,
  STATION,
  STATION_OR_STATION_SET,
  STATION_SET,
  STATION_SET_OR_STATION_GROUP
}

export enum StructureSelctionFilter {
  ANY,
  STATION,
  WAITING_AREA
}

export class StructureSelectionRequest {

  scope: StructureSelectionScope;
  filter: StructureSelctionFilter;

  selection: StructureSelection;
  fixedStationSetId: number;

  constructor(request?: Partial<StructureSelectionRequest>) {
    if (request) {
      this.scope = request.scope;
      this.filter = request.filter;
      this.selection = request.selection;
      this.fixedStationSetId = request.fixedStationSetId;
    }
  }

}

// export class StructureSelectionContextDisabled {

//   scope: StructureSelectionScope;

//   filter: StructureSelctionFilter;

//   selection: StructureSelection;

//   validation$ = new Subject<boolean>();

//   selectionChange$ = new Subject<StructureSelection>();

//   constructor(scope: StructureSelectionScope, selection: StructureSelection, filter: StructureSelctionFilter) {
//     this.scope = scope;
//     this.selection = selection;
//     this.filter = filter;
//   }

//   public setSelection(selection: StructureSelection) {
//     this.selection = selection;
//     this.selectionChange$.next(this.selection);
//     this.validateSelection();
//   }

//   public setStationGroupSelection(stationGroupId: number) {
//     if (this.selection == null) {
//       this.selection = new StructureSelection();
//     }
//     this.selection.stationGroupId = stationGroupId;
//     this.selection.stationSetId = this.selection.fixedStationSetId != null ? this.selection.fixedStationSetId : null;
//     this.selection.stationId = null;
//     this.selectionChange$.next(this.selection);
//     this.validateSelection();
//   }

//   public setStationSetSelection(stationSetId: number) {
//     if (this.selection == null) {
//       this.selection = new StructureSelection();
//     }
//     this.selection.stationSetId = this.selection.fixedStationSetId != null ? this.selection.fixedStationSetId : stationSetId;
//     this.selection.stationId = null;
//     this.selectionChange$.next(this.selection);
//     this.validateSelection();
//   }

//   public setFixedStationSet(fixedStationSetId: number) {
//     if (this.selection == null) {
//       this.selection = new StructureSelection();
//     }
//     this.selection.fixedStationSetId = fixedStationSetId;
//     this.selection.stationSetId = fixedStationSetId;
//     this.validateSelection();
//   }

//   public setStationSelection(stationId: number) {
//     if (this.selection == null) {
//       this.selection = new StructureSelection();
//     }
//     this.selection.stationId = stationId;
//     this.selectionChange$.next(this.selection);
//     this.validateSelection();
//   }

//   private validateSelection() {
//     let valid = true;
//     if (this.selection.fixedStationSetId != null && this.selection.fixedStationSetId !== this.selection.stationSetId) {
//       valid = false
//     } else {
//       if (this.scope === StructureSelectionScope.ANY) {
//         valid = this.selection.stationId != null || this.selection.stationSetId != null || this.selection.stationGroupId != null;
//       } else if (this.scope === StructureSelectionScope.STATION) {
//         valid = this.selection.stationId != null && this.selection.stationSetId != null && this.selection.stationGroupId != null;
//       } else if (this.scope === StructureSelectionScope.STATION_SET) {
//         valid = this.selection.stationId == null && this.selection.stationSetId != null && this.selection.stationGroupId != null;
//       } else if (this.scope === StructureSelectionScope.STATION_OR_STATION_SET) {
//         valid = this.selection.stationSetId != null && this.selection.stationGroupId != null;
//       } else if (this.scope === StructureSelectionScope.STATION_SET_OR_STATION_GROUP) {
//         valid = this.selection.stationId == null && this.selection.stationGroupId != null;
//       }
//     }

//     this.validation$.next(valid);
//   }

// }
